import PropTypes from "prop-types";

import Button from "../Button";

import "./toggle.scss";

const Toggle = ({ leftText, rightText, selectedOption, disabled, onClick }) => {
  const handleClick = () => {
    onClick(selectedOption === "left" ? "right" : "left");
  };

  return (
    <div className="toggle">
      <Button
        variant={selectedOption === "left" ? "primary" : "secondary"}
        onClick={handleClick}
        aria-label={leftText}
      >
        {leftText}
      </Button>
      <Button
        variant={selectedOption === "right" ? "primary" : "secondary"}
        onClick={handleClick}
        aria-label={rightText}
      >
        {rightText}
      </Button>
    </div>
  );
};

export const toggleSides = ["left", "right"];

Toggle.propTypes = {
  leftText: PropTypes.string,
  rightText: PropTypes.string,
  selectedOption: PropTypes.oneOf(toggleSides),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

Toggle.defaultProps = {
  leftText: "",
  rightText: "",
  selectedOption: "left",
  disabled: false,
  onClick: undefined,
};

export default Toggle;
